import { render } from "./BorderFooterTop.vue?vue&type=template&id=0a06d45e&scoped=true"
import script from "./BorderFooterTop.vue?vue&type=script&lang=js"
export * from "./BorderFooterTop.vue?vue&type=script&lang=js"

import "./BorderFooterTop.vue?vue&type=style&index=0&id=0a06d45e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a06d45e"]])

export default __exports__